import React, { useState, useEffect } from 'react';
import '../styles/Contact.css';
import { MapPin, Phone, Mail } from 'lucide-react';

export default function ContactUs() {
  const [isVisible, setIsVisible] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus(null);

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || 'Something went wrong');

      setSubmitStatus({ type: 'success', message: '✅ Message sent successfully! We will contact you soon.' });
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (err) {
      setSubmitStatus({ type: 'error', message: '❌ ' + (err.message || 'Failed to send message. Please try again.') });
    }
  };

  return (
    <div className="contact-us-wrapper">
      {/* Hero Banner */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Contact Us</h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="contact-main-wrapper">
        {/* Left Section - Contact Info */}
        <div className="contact-left-section">

          {/* Address */}
          <div className="contact-info-group">
            <h3 className="contact-group-title">Address</h3>
            <div className="contact-item">
              <MapPin size={32} className="contact-iconco" strokeWidth={1.5} />
              <p className="contact-link">National Highway 62 Sukhadia Circle <br />SriGanganagar (Raj)</p>
            </div>
          </div>

          {/* Email Me */}
          <div className="contact-info-group">
            <h3 className="contact-group-title">Email Me</h3>
            <div className="contact-item">
              <Mail size={32} className="contact-iconco" strokeWidth={1.5} />
              <a href="mailto:bihanischool@yahoo.in" className="contact-link">
                bihanischool@yahoo.in
              </a>
            </div>
          </div>

          {/* Call Me */}
          <div className="contact-info-group">
            <h3 className="contact-group-title">Call Me</h3>
            <div className="contact-item">
              <Phone size={32} className="contact-iconco" strokeWidth={1.5} />
              <a href="tel:+01542466778" className="contact-link">
                +01542466778
              </a>
            </div>
          </div>

        </div>

        {/* Right Section - Contact Form */}
        <div className="contact-right-section">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row-two">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                className="form-input"
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>

            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="form-input full-width"
              required
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              className="form-input full-width"
              required
            />

            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              className="form-textarea"
              rows="5"
              required
            ></textarea>

            {/* Submit Status Message */}
            {submitStatus && (
              <div className={`form-status form-status--${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}

            <button type="submit" className="submit-btn">Submit Form</button>
          </form>
        </div>
      </div>

      {/* Map Section */}
      <div className="map-section">
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3458.183550689356!2d73.87325717605185!3d29.916617524614967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3917b517a6d677c7%3A0x5f0cf402eb103!2sSeth%20G.L.Bihani%20S.D.Sr.Sec.School%2C%20Sriganganagar!5e0!3m2!1sen!2sin!4v1770871479856!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
}